export interface ShowCase {
  id: number;
  name: string;
  thumbnail: string | null;
  picture: string | null;
  cover: string | null;
  type: string;
  totalUsedTimes: number;
  totalReactions: number;
  createdAt: string;
  previews: string[];
  isWorkflow: boolean;
  provider: {
    username: string,
    picture: string | null,
    publicAddress: string,
  };
  workflow: null | {
    nodeCount: number,
  };
}

export enum KEY_SORT {
  CREATED = 'createdAt',
  LIKE = 'totalLike',
  RUN = 'totalRun',
}

export const LIST_SORT = [
  {
    key: KEY_SORT.CREATED,
    title: 'Date Created',
    values: [
      {
        text: 'Neweset',
        value: 'DESC'
      },
      {
        text: 'Oldest',
        value: 'ASC'
      },
    ],
  },
  {
    key: KEY_SORT.LIKE,
    title: 'Total Reactions',
    values: [
      {
        text: 'Descending',
        value: 'DESC'
      },
      {
        text: 'Ascending',
        value: 'ASC'
      },
    ],
  },
  {
    key: KEY_SORT.RUN,
    title: 'Total Run',
    values: [
      {
        text: 'Descending',
        value: 'DESC'
      },
      {
        text: 'Ascending',
        value: 'ASC'
      },
    ],
  },
]